<template>

<div class="row justify-content-center mt-2">
    <div class="col-xl-3 col-md-4 col-sm-6 mb-5 d-flex justify-content-center"
         v-for='m in models'>
        <div class="vote-item">
            <div class="vote-header gradient-bck">
                <span class="vote-persent">
                    {{ getPercent( m.votes ) }}%
                </span>

                <button @click='loginRedirect'  class="not-vote vote" v-if='!user'>
                    <span class="vote-inner" data-toggle="tooltip" data-placement="bottom" 
                         title="Only members can vote!">
                        <span class="material-icons-round icon">
                            &#xe8dc;
                        </span>
                        <span class="text">
                            Vote
                        </span>
                    </span>
                </button>

                <button v-if='user' @click='vote(m)' class="vote-btn vote">
                    <span class="vote-inner">
                        <span class="material-icons-round icon">
                            &#xe8dc;
                        </span>
                        <span class="text">
                            Vote
                        </span>
                    </span>
                </button>

                <img :src="m.avatar_thumb" alt="Contestant Image" class="img-fluid">
            </div>

            <div class="vote-body mt-3">
                <h5 class="font-weight-normal mb-1">
                    {{ m.name }}
                </h5>

                <a :href="url('models/' + m.slug)" class="link-slideright d-inline-block text-uppercase text-xs-small">
                    <span class="d-flex align-items-center">
                        <span>See The Profile</span>
                        <span class="material-icons-round m-0 text-small">&#xe5cc;</span>
                    </span>
                </a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        props : ['c'],

        created() {
           
        },

        data() { 

            return {
                isReady : false,
                models : [],

                total : 0,
            }
            
        },

        methods : {

            getData() {

                this.ajax.call('cmp:gcl', { c : this.c }, (r) => {
                    if( r.status == 'success' ) {
                        this.models = r.data.m;
                        this.userVote = r.data.v;

                        for( var i in this.models ) {
                            if( this.models[i].votes ) {
                                this.total += parseInt( this.models[i].votes );
                            }
                        }
                    }
                })
            },

            vote( m ) {

                if( this.userVote && this.userVote.model_id == m.id ) {
                    $.notify("You have already voted for this model","success");
                    return;
                }

                this.ajax.call('cmp:vt', { cm : m.cm_id }, (r) => {
                    
                    if( r.status == 'success' ) {

                        if( this.userVote) {
                         
                            $.notify("Your vote was changed","success");

                            for( var i in this.models ) {
                                if( this.models[i].id == this.userVote.model_id ) {
                                    this.models[i].votes -= this.userVote.points;
                                }
                                if( this.models[i].id == r.data.model_id ) {
                                    this.models[i].votes += r.data.points;
                                }
                            }
                       
                        } else {
                            
                            this.total += parseInt( r.data.points );
                            $.notify("Thank you for your vote","success");
                        
                        }

                        this.userVote = r.data;

                    }

                });

            },

            getPercent( num ) {
                var num = parseInt(num);

                if( this.total == 0 || !num ) {
                    return 0;
                }

                return (num / this.total * 100).toFixed(1);
            }

        }

    }
</script>
